"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PreKeyAuth = (function () {
    function PreKeyAuth() {
    }
    PreKeyAuth.INVALID = 'Invalid';
    PreKeyAuth.UNKNOWN = 'Unknown';
    PreKeyAuth.VALID = 'Valid';
    return PreKeyAuth;
}());
exports.default = PreKeyAuth;
//# sourceMappingURL=PreKeyAuth.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/keys/PreKeyAuth.js
// module id = 109
// module chunks = 0 1